<br>
<div [innerHtml]="label | HTMLFormatter" [ngClass]="label_class" [style]="style"></div>